<div class="w-full flex flex-row items-start gap-x-4 rounded-md hover:bg-gray-100 dark:hover:bg-gray-800 p-2">
    <div class="shrink-0">
        <button (click)="expanded.set(!expanded())" type="button" class="fab-button-secondary-small text-secondary">
            @if (expanded()) {
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
                <path d="m6 9 6 6 6-6" />
            </svg>
            } @else {
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="size-5">
                <path d="m9 18 6-6-6-6" />
            </svg>
            }
        </button>
    </div>

    <!-- Collapsed Content -->
    @if (!expanded()) {
    <div (click)="expanded.set(!expanded())" class="flex-1 flex flex-col gap-y-2 hover:cursor-pointer">
        <label for="ad-group-name-input" class="block text-md font-medium text-primary">
            Device
        </label>
        <ul role="list" class="flex flex-col gap-y-0 text-gray-600 dark:text-gray-400">
            <li class="inline-flex gap-x-3">
                <p class="text-sm text-primary font-semibold">Operating Systems: </p>
                <p class="text-sm text-secondary">{{ operatingSystemsSummaryLabel() }}</p>
            </li>
        </ul>
    </div>
    }
    <!-- Collapsed Content - END -->

    <!-- Opened Content -->
    @if (expanded()) {
    <div class="flex-1 flex flex-col gap-y-2">

        <label for="ad-group-name-input" class="block text-md font-medium text-primary">
            Device
        </label>

        <div class="grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-6">
            <div class="sm:col-span-3">
                <p id="device-operating-systems-label" class="block text-sm/6 font-medium text-gray-900 dark:text-white">
                    Operating system</p>
                <p id="device-operating-systems-hint" class="text-xs text-gray-500 dark:text-gray-400">Choose which
                    device platforms can receive your ads, or all operating systems.
                </p>
                <div class="mt-1 isolate flex w-full min-w-0 rounded-md shadow-xs dark:shadow-none" role="radiogroup"
                    aria-labelledby="device-operating-systems-label" aria-describedby="device-operating-systems-hint">
                    @for (opt of operatingSystemOptions; track opt.mode) {
                    <button type="button" role="radio" [attr.aria-checked]="isOperatingSystemsModeSelected(opt.mode)"
                        (click)="selectOperatingSystemsMode(opt.mode)"
                        [class]="operatingSystemSegmentClass(opt.mode, $index)">
                        {{ opt.label }}
                    </button>
                    }
                </div>
            </div>
        </div>
    </div>
    }
    <!-- Opened Content - END -->
</div>